import { fetchFromOldApi } from '~/services/Http';

import { SOLAPULSE_API } from '../constants';
import {
  AnswerPreProcess,
  ServerSurveyResults,
  SurveyAnswer,
  SurveyNotification,
} from '../types';

import { generateSurvey, responsesMap } from './mappers';

export const getNotifications = (): Promise<SurveyNotification[]> =>
  fetchFromOldApi(`${SOLAPULSE_API}/notifications`).then((r: Response) =>
    r.json().then((r) => r.data),
  );

export const moodSurveyAnswer = (value: number): Promise<number> => {
  return fetchFromOldApi(`/json/survey`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(value.toString()),
  }).then((r) => r.json());
};

export const getSurveyAnswers = (id: string): Promise<SurveyAnswer> => {
  return fetchFromOldApi(`${SOLAPULSE_API}/${id}/view`).then((r) =>
    r.json().then((r) => generateSurvey(r)),
  );
};

export const answerTheSurvey = (
  survey: SurveyAnswer,
  responses: AnswerPreProcess,
) => {
  return fetchFromOldApi(`${SOLAPULSE_API}/${survey.id}/answer`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(responsesMap(survey, responses)),
  }).then((r) => r.json());
};

export const getSurveyResults = (id: string): Promise<ServerSurveyResults> => {
  return fetchFromOldApi(`${SOLAPULSE_API}/${id}/report`).then((r) => r.json());
};

export const getFilteredSurveyResults = (
  id: string,
  unitId: number,
): Promise<ServerSurveyResults> => {
  return fetchFromOldApi(`${SOLAPULSE_API}/${id}/report?unitId=${unitId}`).then(
    (r) => r.json(),
  );
};
